import { render, staticRenderFns } from "./temp-list.vue?vue&type=template&id=1f281707&scoped=true&"
import script from "./temp-list.vue?vue&type=script&lang=ts&"
export * from "./temp-list.vue?vue&type=script&lang=ts&"
import style0 from "./temp-list.vue?vue&type=style&index=0&id=1f281707&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f281707",
  null
  
)

export default component.exports